import {
  IonAvatar,
  IonItem,
  IonLabel,
  IonList,
  IonNote,
  IonSkeletonText,
} from "@ionic/react";
import "./ListSkeleton.css";

export const ListSkeleton = ({ rows }) => {
  return (
    <div className={"list-skeleton-root"}>
      <IonList lines="none">
        {Array.from(Array(rows), (e, i) => {
          return (
            <IonItem key={i} style={{ height: 72 }}>
              <IonAvatar
                slot="start"
                style={{ width: 42, height: 42, "--border-radius": "8px" }}
              >
                <IonSkeletonText animated />
              </IonAvatar>
              <IonLabel className={"ion-text-wrap"}>
                <h2>
                  <IonSkeletonText animated style={{ width: "50%" }} />
                </h2>
                <p>
                  <IonSkeletonText animated style={{ width: "25%" }} />
                </p>
              </IonLabel>
              <IonNote slot="end">
                <IonLabel className={"ion-text-wrap ion-text-right"}>
                  <h2>
                    <IonSkeletonText animated style={{ width: "50px" }} />
                  </h2>
                  <p>
                    <IonSkeletonText animated style={{ width: "50px" }} />
                  </p>
                </IonLabel>
              </IonNote>
            </IonItem>
          );
        })}
      </IonList>
    </div>
  );
};
